import { createReducer, on } from '@ngrx/store';
import { ErrorResponse, IGenericError } from 'src/app/core/models/generic-models';
import * as fromWithdrawalRejectionReasonAction from '../actions/withdrawal-rejection-reason.actions';
import { IRejectionReason } from '../models/rejection-reason.model';

export const withdrawalRejectionReasonFeatureKey = 'withdrawalRejectionReason';

export interface WithdrawalRejectionReasonState {
  loading: boolean;
  response: IRejectionReason[];
  error: IGenericError<ErrorResponse>;
}

export const initialState: WithdrawalRejectionReasonState = {
  loading: false,
  response: undefined,
  error: undefined
};

export const reducer = createReducer(
  initialState,
  on(fromWithdrawalRejectionReasonAction.loadWithdrawalRejectionReasons, state => ({
    ...state,
    loading: true,
    error: undefined
  })),
  on(fromWithdrawalRejectionReasonAction.loadWithdrawalRejectionReasonsSuccess, (state, action) => ({
    ...state,
    loading: false,
    response: action.response
  })),
  on(fromWithdrawalRejectionReasonAction.loadWithdrawalRejectionReasonsFailure, (state, action) => ({
    ...state,
    loading: false,
    error: action.error
  }))
);

export const getWithdrawalRejectionReasons = (state: WithdrawalRejectionReasonState) => state.response;
export const getWithdrawalRejectionReasonsLoading = (state: WithdrawalRejectionReasonState) => state.loading;
export const getWithdrawalRejectionReasonsFailure = (state: WithdrawalRejectionReasonState) => state.error;
